import { TUserData } from '../../types/userData';

export const INITIAL_USER_STATE: TUserData = null;

export const userDataReducer = (state: TUserData = INITIAL_USER_STATE) => state;
